module.exports = __webpack_public_path__ + "img/icon_map_5_on_111.2a546f2c.png";